import { Immutable } from "immer";
import React from "react";
import { FormInput } from "tsi-common-react/src/forms/FormInput/index";
import { t } from "ttag";

type IProps = Immutable<{
    isSubmitting: boolean;
}> & {
    onCancel: () => void;
    onSubmit: (recipient: string) => void;
};

export const LocatorSendSingleStoreForm = (props: IProps): React.ReactNode => {
    const [recipient, setRecipient] = React.useState("");

    const onRecipientChange = (e: React.FormEvent<HTMLInputElement>) => {
        setRecipient(e.currentTarget.value);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onSubmit(recipient);
    };

    return (
        <div className="send__content survey__carousel">
            <h1>{t`Email Me Details About This Store.`}</h1>
            <form onSubmit={onSubmit}>
                <fieldset>
                    <legend className="ada-screenreader-only">
                        {t`Email Me Details About This Store.`}
                    </legend>
                    <p className="send__required-legend" aria-hidden="true">
                        {t`* indicates a required field`}
                    </p>
                    <div className="send__inputs">
                        <FormInput
                            id="send-store-recipient"
                            name="send-store-recipient"
                            required={true}
                            label={t`Email Address`}
                            placeholder={t`Enter an Email Address`}
                            type={"email"}
                            value={recipient}
                            onChange={onRecipientChange}
                            disabled={props.isSubmitting}
                        />
                    </div>
                    <div className="send__actions">
                        <button
                            className="button send__button"
                            type="submit"
                            aria-label={t`Send`}
                            disabled={props.isSubmitting}
                        >
                            {t`Send`}
                        </button>
                        <a
                            title={t`Close`}
                            className="send__cancel modal-cancel"
                            onClick={props.onCancel}
                            href="#"
                        >
                            {t`Cancel`}
                        </a>
                    </div>
                </fieldset>
            </form>
        </div>
    );
};
